import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export function useShipperNetwork() {
  const { role } = useRoleContext();

  const url =
    role?.type === "SHIPPER" ? `/shippers/${role.id}/followers` : null;

  const { data, loading, error, refetch } = useSwrFetch<FollowingCarrier[]>({
    url,
    errorMessage: "Failed to fetch shipper network",
  });

  return {
    followingCarriers: data ?? [],
    loading,
    error,
    refetch,
    success: data !== undefined && error == null,
  };
}
